import { PageWatchState } from './PageWatch';
import { Icons, SVGIcon } from '../../../../components/atoms/SVG';
import { BtnModifier } from '../../../../components/molecules/Btn';

export const iconLookup: Record<PageWatchState, SVGIcon> = {
  singleWatched: Icons.OBSERVE_EYE,
  parentWatched: Icons.OBSERVATION_INHERITED,
  treeWatched: Icons.OBSERVATION_TREE,
  watchNotSupported: Icons.OBSERVATION_NOT_WANTED,
  neverWatched: Icons.OBSERVATION_NOT_WANTED,
  notWatched: Icons.OBSERVE_EYE,
};

export function getButtonModifier(pageWatchState: PageWatchState) {
  switch (pageWatchState) {
    case 'singleWatched':
    case 'parentWatched':
    case 'treeWatched':
      return [BtnModifier.MINOR_ACTION_ACTIVATED_BLUE, BtnModifier.MINOR_ACTION_ACTIVATED];
    case 'watchNotSupported':
    case 'neverWatched':
    case 'notWatched':
    default:
      return [];
  }
}
